module.exports = __webpack_public_path__ + "img/app1.508e5a1f.png";